var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 42,
    viewBox: "0 0 31 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 13.1498C5 12.6804 5.38056 12.2998 5.85 12.2998H24.15C24.6194 12.2998 25 12.6804 25 13.1498C25 13.6192 24.6194 13.9998 24.15 13.9998H5.85C5.38056 13.9998 5 13.6192 5 13.1498ZM5 18.6668C5 18.1974 5.38056 17.8168 5.85 17.8168H24.15C24.6194 17.8168 25 18.1974 25 18.6668C25 19.1363 24.6194 19.5168 24.15 19.5168H5.85C5.38056 19.5168 5 19.1363 5 18.6668ZM5.85 23.3338C5.38056 23.3338 5 23.7144 5 24.1838C5 24.6533 5.38056 25.0338 5.85 25.0338H24.15C24.6194 25.0338 25 24.6533 25 24.1838C25 23.7144 24.6194 23.3338 24.15 23.3338H5.85Z",
    fill: "url(#paint0_linear_385_667)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2108 5.16028L25.2809 0.803684C25.1525 0.690195 24.9873 0.627441 24.816 0.627441H0.701991C0.314407 0.627441 0 0.941848 0 1.32943V41.2648C0 41.6524 0.314407 41.9668 0.701991 41.9668L30.4634 41.9997V40.5628H1.40387V2.03132H24.5506L29.0441 6.00214V31.099C29.0441 31.4866 29.3585 31.801 29.7461 31.801C30.1337 31.801 30.4481 31.4866 30.4481 31.099V5.68592C30.4481 5.485 30.3615 5.29313 30.2108 5.16028Z",
    fill: "url(#paint1_linear_385_667)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2188 5.13488L25.1361 0.778285C24.921 0.593853 24.6182 0.552691 24.3601 0.66969C24.1027 0.788603 23.9375 1.046 23.9375 1.32956V5.68616C23.9375 6.08714 24.2626 6.41229 24.6636 6.41229H29.7464C30.05 6.41229 30.3218 6.22297 30.4273 5.93834C30.5327 5.65308 30.4495 5.33272 30.2188 5.13488ZM25.3897 4.96002V2.9083L27.7837 4.96002H25.3897Z",
    fill: "url(#paint2_linear_385_667)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4709 30.5376H29.0187V41.6893H30.4709V30.5376Z",
    fill: "#7C76FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_385_667",
    x1: 7.06897,
    y1: 25.0338,
    x2: 24.6399,
    y2: 11.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8567FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C90FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_385_667",
    x1: 15.2317,
    y1: 0.627441,
    x2: 15.2317,
    y2: 41.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C90FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8567FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_385_667",
    x1: 27.205,
    y1: 0.604004,
    x2: 27.205,
    y2: 6.41229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C90FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8567FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.3c3e2decb5cb9f90433663653cabb7ac.svg";
export { ForwardRef as ReactComponent };